import getNegativeOrPositiveValue from "@/helper/getNegativeOrPositiveValue";

export function getTotalDisplay({ totalValue, miles, dollar, gallons, sum }) {
	const styleTotalClass = getNegativeOrPositiveValue(totalValue);
	if (miles) return `Σ: <span class="total">${ totalValue } mi</span>`;
	if (dollar) return `Σ: <span class="${ styleTotalClass }">$ ${ totalValue }</span>`;
	if (gallons) return `Σ: <span class="total"> ${ totalValue } g</span>`;
	if (sum) return `Σ: <span class="total"> ${ totalValue } </span>`;
	return `n: <span class="total"> ${ totalValue }</span>`;
}
